import { PrintDialog } from '@frontend/assets';
import { PrintableInsuranceReport } from '../components/PrintableInsuranceReport';
import { useDentalInsuranceReportContext } from '../context/DentalInsuranceReportDetailsContext.provider';

export const PrintReport = () => {
  const {
    isPrintDialogVisible,
    hidePrintDialog,
    insuranceEligibilityReportData: { dentalSummaryInfo: { patient } = {} } = {},
  } = useDentalInsuranceReportContext();

  const documentTitle = `${patient?.firstName ?? ''} ${patient?.lastName ?? ''}`.trim() + ` Insurance Report`;

  return (
    <PrintDialog
      show={isPrintDialogVisible}
      onClose={hidePrintDialog}
      showBackgroundGraphics
      documentTitle={documentTitle}
    >
      <PrintableInsuranceReport />
    </PrintDialog>
  );
};
